import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOceanBiogeochemistryV2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 42,
	height: 58,
	viewBox: "0 0 42 58",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M24.11 27.8701V15.8701H15.11V27.4801C8.37 29.3401 3.51 35.9001 4.04 43.5401C4.57 51.1801 10.66 57.4701 18.3 57.8301C26.91 58.2401 34.02 51.1701 34.02 42.4001C34.02 35.7101 29.89 30.0201 24.12 27.8701H24.11Z",
			fill: "#F7DD97"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.11 24.8701V12.8701H12.11V24.4801C5.37 26.3401 0.510002 32.9001 1.04 40.5401C1.57 48.1801 7.66 54.4701 15.3 54.8301C23.91 55.2401 31.02 48.1701 31.02 39.4001C31.02 32.7101 26.89 27.0201 21.12 24.8701H21.11Z",
			stroke: "#256F94",
			strokeWidth: 2,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.79004 36.1101C6.79004 36.1101 11.51 33.4301 16.86 36.1101C22.21 38.7901 23.99 40.5701 27.06 40.5701",
			stroke: "#256F94",
			strokeWidth: 2,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.1101 43.8701C12.2147 43.8701 13.1101 42.9747 13.1101 41.8701C13.1101 40.7655 12.2147 39.8701 11.1101 39.8701C10.0055 39.8701 9.11011 40.7655 9.11011 41.8701C9.11011 42.9747 10.0055 43.8701 11.1101 43.8701Z",
			fill: "#256F94"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.22 47.8102C19.22 48.5702 18.6 49.1902 17.84 49.1902C17.08 49.1902 16.46 48.5702 16.46 47.8102C16.46 47.0502 17.08 46.4302 17.84 46.4302C18.6 46.4302 19.22 47.0502 19.22 47.8102Z",
			fill: "#256F94"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.1101 8.87012V0.870117",
			stroke: "#256F94",
			strokeWidth: 2,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.1101 9.87012V4.87012",
			stroke: "#256F94",
			strokeWidth: 2,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.1101 26.8701V15.8701H40.1101V46.0501C40.1101 48.7101 37.9501 50.8701 35.2901 50.8701H31.1101",
			stroke: "#256F94",
			strokeWidth: 2,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M41 32.8701C39 32.8701 39 31.8701 37 31.8701C35 31.8701 35 32.8701 33 32.8701C31 32.8701 31 31.8701 29 31.8701",
			stroke: "#256F94",
			strokeWidth: 2,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M41 36.8701C39.1667 36.8701 39.1667 35.8701 37.3333 35.8701C35.5 35.8701 35.5 36.8701 33.6667 36.8701C31.8333 36.8701 31.8333 35.8701 30 35.8701",
			stroke: "#256F94",
			strokeWidth: 2,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.1101 21.8701H41.1101",
			stroke: "#256F94",
			strokeWidth: 2,
			strokeLinejoin: "round"
		})
	]
});
export default SvgOceanBiogeochemistryV2;
